/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type AdminSlideListSpecimen = {
    readonly id?: number;
    /**
     * name of the specimen group, should match slide block
     */
    name: string;
    biopsy_type?: AdminSlideListSpecimen.biopsy_type;
    /**
     * Changing this value will ALSO modify the received_date for the case.
     */
    received_date?: string | null;
}

export namespace AdminSlideListSpecimen {

    export enum biopsy_type {
        PUNCH = 'PUNCH',
        SHAVE = 'SHAVE',
        EXCISION = 'EXCISION',
        UNKNOWN = 'UNKNOWN',
    }


}
